// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1s6Ta","form":"styles_form__2fR0A"};